export default class SessionStorage {


    //getters
    static get betSlip() {
        const betSlip = JSON.parse(sessionStorage.getItem('betSlip')) || '';
        return betSlip;
    }
    static get betBuilder() {
        const betSlip = JSON.parse(sessionStorage.getItem('betBuilder')) || '';
        return betSlip;
    }
    static get betBuilderDisplayOdds() {
        const betBuilderDisplayOdds = JSON.parse(sessionStorage.getItem('betBuilderDisplayOdds')) || '';
        return betBuilderDisplayOdds;
    }
    static get betBuilderPossibleWinning() {
        const betBuilderPossibleWinning = JSON.parse(sessionStorage.getItem('betBuilderPossibleWinning')) || '';
        return betBuilderPossibleWinning;
    }
    static get betBuilderAmount() {
        const betBuilderAmount = JSON.parse(sessionStorage.getItem('betBuilderAmount')) || '';
        return betBuilderAmount;
    }


    static get betSlipAmount() {
        const betSlipAmount = JSON.parse(sessionStorage.getItem('betSlipAmount')) || '';
        return betSlipAmount;
    }

    static get betCode() {
        const betCode = JSON.parse(sessionStorage.getItem('betCode')) || '';
        return betCode;
    }

    static get betTab() {
        const betTab = JSON.parse(sessionStorage.getItem('betTab')) || '';
        return betTab;
    }
    static get currentWin() {
        const currentWin = JSON.parse(sessionStorage.getItem('currentWin')) || false;
        return currentWin;
    }
    static get jackpotWinningApproved() {
        const jackpotWinningApproved = JSON.parse(sessionStorage.getItem('jackpotWinningApproved')) || false;
        return jackpotWinningApproved;
    }
    static get betSlipCouponId() {
        const betSlipCouponId = JSON.parse(sessionStorage.getItem('betSlipCouponId')) || false;
        return betSlipCouponId;
    }
    static get couponCodeText() {
        const couponCode = JSON.parse(sessionStorage.getItem('couponCode')) || false;
        return couponCode;
    }


    //setters

    static set betSlip(betSlip) {
        sessionStorage.setItem('betSlip', JSON.stringify((betSlip)));
    }
    static set betBuilder(betBuilder) {
        sessionStorage.setItem('betBuilder', JSON.stringify((betBuilder)));
    }
    static set betBuilderDisplayOdds(displayOdds) {
        sessionStorage.setItem('betBuilderDisplayOdds', JSON.stringify((displayOdds)));
    }
    static set betBuilderPossibleWinning(possibleWinnings) {
        sessionStorage.setItem('betBuilderPossibleWinning', JSON.stringify((possibleWinnings)));
    }
    static set betBuilderAmount(amount) {
        sessionStorage.setItem('betBuilderAmount', JSON.stringify((amount)));
    }

    static set betSlipAmount(betSlipAmount) {
        sessionStorage.setItem('betSlipAmount', JSON.stringify((betSlipAmount)));
    }

    static set betCode(betCode) {
        sessionStorage.setItem('betCode', JSON.stringify((betCode)));
    }
    
    static set betTab(betTab) {
        sessionStorage.setItem('betTab', JSON.stringify((betTab)));
    }
    static set currentWin(currentWin) {
        sessionStorage.setItem('currentWin', JSON.stringify((currentWin)));
    }
    static set jackpotWinningApproved(jackpotWinningApproved) {
        sessionStorage.setItem('jackpotWinningApproved', JSON.stringify((jackpotWinningApproved)));
    }
    static set betSlipCouponId(betSlipCouponId) {
        sessionStorage.setItem('betSlipCouponId', JSON.stringify((betSlipCouponId)));
    }
    static set couponCodeText(couponCode) {
        sessionStorage.setItem('couponCode', JSON.stringify((couponCode)));
    }

}